import { IS_PROD } from "./constants"

const showFlag = !IS_PROD

export const Flags = {
  General: {
    Example: showFlag,
    DarkMode: false,
    Theming: false,
    Rebrand: true,
    CSLeaseChart: showFlag,
    CSLeaseChartPdf: showFlag,
  },
} as const

export type FlagsType = typeof Flags
